import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * BeaconSDK上报到Atta
 * @Author: mickyzeng
 * @Date: 2022-11-22 17:43:00
 */
import BeaconAction from '@tencent/beacon-web-sdk';
import { setCookie, getCookies } from './util_03_cookie';
import { isClient, isServer } from './util_00_env';
import { throttle } from './util_23_throttle';
import { parseQueryString, updateQueryString } from './util_09_url';
import { addEvent } from './util_10_lang';
import { storage } from './util_05_storage';
import { isVisible, detectDomIsVisible } from './util_12_dom';
import { isPC, isMQQ, isWeiBo, isWeixin, isFudaoApp, getUin, isWeixinMinProgram } from './util_04_ua';
var globalOptions = {}; // 为了避免 URL 在 Webview 中打开后, from 被覆盖, 修改为 fr 作为参数名

var FROM_URL_KEY = 'fr'; // 兼容老的 from 数据

var FROM_URL_OLD_KEY = 'from'; // Cookie 中的参数名

var FROM_COOKIE_KEY = 'from_source';
var REPORT_DOM_ATTR = 'data-modid';
var REPROT_DOM_SELECTOR = "[".concat(REPORT_DOM_ATTR, "]");
var REPORT_DATA_ATTR = 'data-biz';
var PRESET_STORAGE_KEY = 'biz_preset';
var beacon = null;
var REPORT_DATA = {};
var hasReportExposePage = false;
/**
 * 把 form 值存储到 Cookie
 * 有效期: 15 min
 * @param {string} from
 */

function setFromCookie(from) {
  if (isServer) {
    console.error('Cannot set cookie with server render.');
    return '';
  }

  var exp = new Date();
  exp.setTime(exp.getTime() + 15 * 60 * 1000);
  return setCookie({
    name: FROM_COOKIE_KEY,
    value: from,
    domain: '.fudao.qq.com',
    time: exp.toUTCString()
  });
}
/**
 * 从 Cookie 获取 From 值
 * @returns {string | null}
 */


function getFromCookie() {
  if (isServer) {
    console.error('Cannot get document with server render.');
    return null;
  }

  var froms = getCookies(FROM_COOKIE_KEY);

  if (froms.length === 0) {
    return null;
  }

  for (var i = 0; i < froms.length; i++) {
    var from = froms[i];
    var isValid = !['none', ''].includes(from); // TODO: REMOVE
    // 手Q webview 会种一个 key 为 from_source, value 为 qq 的 cookie
    // 还特么永不过期, 等手Q 修复了这个问题后, 去掉该逻辑
    // 坑爹...

    var isQQFromSource = isMQQ() && from === 'qq';

    if (isValid && !isQQFromSource) {
      return from;
    }
  }

  return null;
}
/**
 * 返回环境信息
 * @returns {string}
 */


function getFromValueFromEnv() {
  if (isServer) {
    console.error('Cannot get navigator with server render.');
    return '';
  } // 辅导 APP


  if (isFudaoApp()) {
    return 'app';
  } // 手机 QQ


  if (isMQQ()) {
    return 'qq';
  } // 微信


  if (isWeixin) {
    return 'wechat';
  } // 小程序 上报成微信


  if (isWeixinMinProgram) {
    return 'wechat';
  } // 微博


  if (isWeiBo) {
    return 'weibo';
  } // PC


  if (isPC()) {
    return 'web';
  }

  return 'h5';
}
/**
 * 从 URL 获取 From 值
 * @param {string?} url
 * @param {string?} key
 * @returns {string}
 */


function getFromValueFromUrlQuery(url, key) {
  if (isServer) {
    console.error('Cannot get window with server render.');
    return null;
  }

  var query = parseQueryString(url || window.location.href);
  return query[key || FROM_URL_KEY];
}
/**
 * 获取 From 值
 * From 存在优先级
 * URL fr 参数 > URL from 参数 > Cookie from_source 参数
 * 没有的话则 UA 判断补齐
 * @param {string} url
 * @returns {string}
 */


function getFromValue(url) {
  if (isServer) {
    console.error('Cannot get fromValue with server render.');
    return '';
  }

  var fromQueryAndCookie = getFromValueFromUrlQuery(url) || getFromValueFromUrlQuery(url, FROM_URL_OLD_KEY) || getFromCookie();
  return fromQueryAndCookie || getFromValueFromEnv();
}
/**
 * 将 fr 加入到 URL 中, 同时保存到 Cookie
 * @param {string} url
 * @returns {string}
 */


function syncFromValue(url) {
  var from = getFromValue(url);
  setFromCookie(from);
  return updateQueryString(url, 'fr', from);
} // 获取 refer


function getRefer() {
  if (!isClient) {
    return '';
  }

  return document.referrer;
}
/**
 * 格式化 platform 值
 * @returns {string} 返回平台类型 pc, ios, android, other
 */


function formatPlatform() {
  var platform = 0;

  if (!isClient) {
    return platform;
  }

  if (/Android/i.test(navigator.userAgent)) {
    platform = 1;
  } else if (/iPhone|iPad|iPod|iOS/i.test(navigator.userAgent)) {
    platform = 2;
  } else if (isPC()) {
    platform = 3;
  }

  return platform;
}
/**
 * 格式化 terminal 值
 * @returns {string} 返回终端类型 web, native, h5 其一
 */


function formatTerminal() {
  var terminal = '';

  if (!isClient) {
    return terminal;
  }

  if (isFudaoApp()) {
    terminal = 'native';
  } else if (isPC()) {
    terminal = 'web';
  } else {
    terminal = 'h5';
  }

  return terminal;
} // 获取当前页面的 URL


function getUrl() {
  if (!isClient) {
    return '';
  }

  return window.location.href;
}

var DEFAULT_REPORT_DATA = {
  product_id: '',
  // 固定分配
  platform: formatPlatform(),
  terminal: formatTerminal(),
  env: getFromValueFromEnv(),
  event_code: '',
  session_id: '',
  page: 'unknown',
  app_env: 'unknown',
  page_step: 0,
  url: getUrl(),
  // 当前页面url
  refer_url: getRefer(),
  // 来源页面的url
  uid: getUin(),
  // 登录用户上报uid(访客也有uid，是设备号转换过去的tinyid@lilinli)
  login_type: 1,
  // 1-手机号，2-访客（目前只支持手机号登录）
  from_source: getFromValue(),
  // 渠道 fr值，需要透传
  module: '',
  postition: '',
  refer_page: '',
  refer_module: '',
  // 来源模块
  refer_position: '' // 来源位置

};

var ReportStorage = /*#__PURE__*/function () {
  function ReportStorage(storageKey) {
    _classCallCheck(this, ReportStorage);

    _defineProperty(this, "storageKey", void 0);

    this.storageKey = storageKey || 'report_storage';
  }
  /**
   * 获取本地缓存中的全量上报数据
   * @memberof module:biz-report
   * @returns {object} 缓存中的数据
   */


  _createClass(ReportStorage, [{
    key: "getAll",
    value: function getAll() {
      return storage.getGlobal(this.storageKey) || {};
    }
    /**
     * 保存全量上报数据到本地缓存
     * @param {object} 全量上报数据
     */

  }, {
    key: "setAll",
    value: function setAll(data) {
      return storage.setGlobal(this.storageKey, data);
    }
    /**
     * 保存单条上报数据到本地缓存
     * @memberof module:biz-report
     * @param {string} seq 特定的 seq
     * @param {object} data 要保存的数据
     */

  }, {
    key: "set",
    value: function set(seq, data) {
      var bizStorage = this.getAll();
      bizStorage[seq] = data;
      storage.setGlobal(this.storageKey, bizStorage);
    }
    /**
     * 根据 seqs 批量删除缓存数量
     * @memberof module:biz-report
     * @param { string|array } [seqs=[]] 要删除的 seqs
     */

  }, {
    key: "del",
    value: function del() {
      var seqs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var bizStorage = this.getAll();
      seqs = typeof seqs === 'string' ? [seqs] : seqs;
      seqs.forEach(function (seq) {
        delete bizStorage[seq];
      });
      this.setAll(bizStorage);
    }
  }]);

  return ReportStorage;
}();

var presetStorage = new ReportStorage(PRESET_STORAGE_KEY); // 获取预设数据

function getPreset() {
  var currPageLink = window.location.href.replace(/^https?:/, '').replace(/_lv=\d+&*/, '');
  var presetDatas = presetStorage.getAll();
  var currPresetData = presetDatas[currPageLink];

  if (currPresetData) {
    presetStorage.del(currPageLink);
    return currPresetData;
  }

  return {};
} // 保存预设数据，用于跳转到下一个页面上报的 refer_* 字段


function setPreset(params) {
  var url = params.url,
      pureParams = _objectWithoutProperties(params, ["url"]);

  var module = pureParams.module,
      position = pureParams.position;

  if (url) {
    var formatUrl = url.replace(/^https?:/, '');
    var reportParams = {
      ctime: new Date().getTime(),
      refer: window.location.href,
      refer_page: REPORT_DATA.page,
      refer_module: module,
      refer_position: position
    };
    presetStorage.set(formatUrl, reportParams);
  }
}
/**
 * 合并上报
 */


function mergeReport(params) {
  beacon.onUserAction(params.event_code || params.event || 'unknown_event', _objectSpread(_objectSpread({}, REPORT_DATA), params));
}
/**
 * 立即上报
 */


function directReport(params) {
  beacon.onDirectUserAction(params.event_code || params.event || 'unknown_event', _objectSpread(_objectSpread({}, REPORT_DATA), params));
}
/**
 * 关闭前上报
 */


function beaconReport(params) {
  beacon.onSendBeacon(params.event_code || params.event || params.code, _objectSpread(_objectSpread({}, REPORT_DATA), params));
}

// 对外暴露的上报接口
function report() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'merge';

  var reportData = _objectSpread(_objectSpread({}, REPORT_DATA), params);

  setPreset(reportData);

  if (type === 'direct') {
    // 立即上报
    directReport(reportData);
  } else if (type === 'unload') {
    // 关闭前上报
    // https://developer.mozilla.org/zh-CN/docs/Web/API/Navigator/sendBeacon
    beaconReport(reportData);
  } else {
    // 合并上报
    mergeReport(reportData);
  }
} // 页面曝光上报


function reportExposePage() {
  if (globalOptions.isAutoExposePage && !hasReportExposePage) {
    hasReportExposePage = true;
    report({
      event_code: 'pageview'
    });
  }
} // 上报曝光的 dom


function reportExposeDom(doms) {
  _toConsumableArray(doms).forEach(function (dom) {
    if (dom && !dom.getAttribute('has-expose') && isVisible(dom)) {
      dom.setAttribute('has-expose', 1); // 标记已上报

      report(_objectSpread({
        event_code: 'expose',
        module: dom.getAttribute(REPORT_DOM_ATTR)
      }, JSON.parse(dom.getAttribute(REPORT_DATA_ATTR) || '{}')));
    }
  });
} // 监听页面 onload


function onLoad() {
  var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

  if (document.readyState === 'complete') {
    callback();
  } else {
    addEvent(window, 'load', callback, false);
  }
}

function scrollExposeEvent() {
  var watchDoms = document.querySelectorAll(REPROT_DOM_SELECTOR);
  reportExposeDom(watchDoms);
}

var throttleScrollExposePage = throttle(scrollExposeEvent, 100); // 模块曝光事件绑定

function bindExposeDom(parentDom) {
  onLoad(function () {
    var targetDom = parentDom || window;
    var watchDoms = document.querySelectorAll(REPROT_DOM_SELECTOR);
    reportExposeDom(watchDoms); // 默认触发一次

    addEvent(targetDom, 'scroll', throttleScrollExposePage, false);
  });
} // 间隔上报曝光模块


function intervalReportExpose() {
  setInterval(function () {
    var watchDoms = document.querySelectorAll(REPROT_DOM_SELECTOR);
    reportExposeDom(watchDoms); // 默认触发一次
  }, globalOptions.intervalTime);
} // 事件绑定


function bindEvents() {
  var _globalOptions = globalOptions,
      isUseIntervalExpose = _globalOptions.isUseIntervalExpose;
  detectDomIsVisible({
    getDomEvent: function getDomEvent() {
      var watchDoms = document.querySelectorAll(REPROT_DOM_SELECTOR);
      var doms = [].slice.call(watchDoms);
      return doms;
    },
    callback: function callback(dom) {
      if (dom && !dom.getAttribute('has-expose')) {
        dom.setAttribute('has-expose', '1'); // 标记已上报

        report(_objectSpread({
          event_code: 'expose',
          module: dom.getAttribute(REPORT_DOM_ATTR)
        }, JSON.parse(dom.getAttribute(REPORT_DATA_ATTR) || '{}')));
      }
    },
    options: {
      useInterval: isUseIntervalExpose
    }
  });

  if (isUseIntervalExpose) {
    intervalReportExpose();
  } else {
    bindExposeDom();
  }
}

function setFromValueCookieFromURL() {
  var fr = getFromValueFromUrlQuery();

  if (fr) {
    setFromCookie(fr);
  }
}

var DefaultOptions = {
  isUseIntervalExpose: true,
  intervalTime: 200,
  isAutoExposePage: true
}; // 初始化

function init() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var globalOpts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DefaultOptions;
  var presetData = getPreset();

  var mergedOptions = _objectSpread({
    appkey: '0WEB0V7E3M479F23',
    // 系统或项目id, 必填
    strictMode: false,
    // 严苛模式开关, 打开严苛模式会主动抛出异常, 上线请务必关闭!!!
    delay: 1000,
    // 普通事件延迟上报时间(单位毫秒), 默认1000(1秒),选填
    sessionDuration: 60 * 1000,
    // session变更的时间间隔, 一个用户持续30分钟(默认值)没有任何上报则算另一次 session,每变更一次session上报一次启动事件(rqd_applaunched),使用毫秒(ms),最小值30秒,选填
    onReportSuccess: function onReportSuccess(e) {},
    // 上报成功回调,选填
    onReportFail: function onReportFail(e) {
      console.warn('onReportFail: ', e);
    }
  }, options);

  globalOptions = Object.assign({}, DefaultOptions, globalOpts); // 默认上报数据

  REPORT_DATA = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, DEFAULT_REPORT_DATA), presetData), data), {}, {
    product_id: mergedOptions.appkey
  });

  var mergeConfig = function mergeConfig(info, keys) {
    var cfg = JSON.parse(info);
    var _cfg$page = cfg.page,
        page = _cfg$page === void 0 ? '' : _cfg$page,
        _cfg$module = cfg.module,
        module = _cfg$module === void 0 ? '' : _cfg$module,
        _cfg$position = cfg.position,
        position = _cfg$position === void 0 ? '' : _cfg$position; // 原页面参数到h5就是refer参数

    var refer = {
      refer_page: page,
      refer_module: module,
      refer_position: position
    }; // 移除原页面字段

    delete cfg.page;
    delete cfg.module;
    delete cfg.position;

    if (Array.isArray(keys)) {
      keys.forEach(function (k) {
        REPORT_DATA[k] = cfg[k];
      });
    } else {
      REPORT_DATA = _objectSpread(_objectSpread(_objectSpread({}, REPORT_DATA), refer), cfg);
    }

    var _REPORT_DATA = REPORT_DATA,
        url = _REPORT_DATA.url,
        refer_url = _REPORT_DATA.refer_url;
    window.mqq.invoke('edu', 'updateReportInfo', _objectSpread(_objectSpread({}, REPORT_DATA), {}, {
      url: encodeURIComponent(url),
      refer_url: encodeURIComponent(refer_url),
      duration: Date.now()
    }));
  };

  window.mqq.invoke('edu', 'getReportInfo', function (reportInfo) {
    return mergeConfig(reportInfo);
  });
  window.mqq.invoke('edu', 'getAppInfo', function (appInfo) {
    return mergeConfig(appInfo, ['os_version', 'app_version']);
  });

  if (!beacon) {
    // 创建上报实例单例
    beacon = new BeaconAction(mergedOptions);
    var deviceId = beacon.getDeviceId();
    console.info('【imutils/bizReport】设备ID: ', deviceId); // 延迟绑定事件，等待接口调用完成

    setTimeout(function () {
      reportExposePage();
      bindEvents();
    }, 500); // 初始化URL

    setFromValueCookieFromURL();
    addEvent(window, 'hashchange', setFromValueCookieFromURL, false);
  } else {
    console.warn('【imutils/bizReport】请勿重复初始化beacon');
  }
} // 可修改上报默认数据和beacon默认init 参数


function config() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var globalOpts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  REPORT_DATA = _objectSpread(_objectSpread({}, REPORT_DATA), data);
  globalOptions = Object.assign({}, globalOptions, globalOpts);
  beacon.addAdditionalParams(_objectSpread({}, options));
}

var bizReport = {
  init: init,
  config: config,
  report: report,
  getFromValue: getFromValue,
  syncFromValue: syncFromValue
};

if (isClient) {
  window.bizReport = bizReport;
}
/* eslint-disable import/prefer-default-export */


export { bizReport };